import { PropertyDataCar } from './components';

export const StepTwo = () => <PropertyDataCar />;
